"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserUploadedFile = void 0;
const v1 = __importStar(require("@nimbus/app-analytics-proto/lib/fusebase/app_analytics/v1/events_pb"));
const eventType = "fusebase.app_analytics.v1.UserUploadedFile";
class UserUploadedFile {
    constructor(params) {
        var _a;
        this.eventType = eventType;
        this.fileId = params.fileId;
        this.fileName = params.fileName;
        this.fileUrl = params.fileUrl;
        this.asString = (_a = params.asString) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    }
    static toProto(event) {
        return new v1.UserUploadedFile({
            fileId: event.fileId,
            fileName: event.fileName,
            fileUrl: event.fileUrl,
            asString: event.asString,
        });
    }
    static fromProto(proto) {
        return new UserUploadedFile({
            fileId: proto.fileId,
            fileName: proto.fileName,
            fileUrl: proto.fileUrl,
            asString: proto.asString,
        });
    }
    static fromRumEvent(event) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        return new UserUploadedFile({
            fileId: (_c = (_b = (_a = event.attributes) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b.context) === null || _c === void 0 ? void 0 : _c.fileId,
            fileName: (_f = (_e = (_d = event.attributes) === null || _d === void 0 ? void 0 : _d.attributes) === null || _e === void 0 ? void 0 : _e.context) === null || _f === void 0 ? void 0 : _f.fileName,
            fileUrl: (_j = (_h = (_g = event.attributes) === null || _g === void 0 ? void 0 : _g.attributes) === null || _h === void 0 ? void 0 : _h.context) === null || _j === void 0 ? void 0 : _j.fileUrl,
            asString: (_m = (_l = (_k = event.attributes) === null || _k === void 0 ? void 0 : _k.attributes) === null || _l === void 0 ? void 0 : _l.context) === null || _m === void 0 ? void 0 : _m.asString,
        });
    }
}
exports.UserUploadedFile = UserUploadedFile;
UserUploadedFile.eventType = eventType;
//# sourceMappingURL=UserUploadedFile.js.map